import { stripHtmlTags } from "./utils";

export function formatEntityName(entityName: string, title: string) {
  title = stripHtmlTags(title);
  return `${entityName} «${title}»`;
}

export function replaceEntityName(template: string, entityName: string) {
  return template.replace("{EntityName}", entityName);
}
